import { 
  fetchAutomationsStart, 
  fetchAutomationsSuccess, 
  fetchAutomationsFailure,
  fetchFoldersStart,
  fetchFoldersSuccess,
  fetchFoldersFailure
} from '../slices/automationsSlice';
import automationService from '../../services/api/automationsService';

export const fetchAutomations = () => async (dispatch) => {
  try {
    dispatch(fetchAutomationsStart());
    console.log('Fetching automations in thunk');
    const response = await automationService.getAutomations();
    console.log('Automations response:', response.data);
    dispatch(fetchAutomationsSuccess(response.data));
  } catch (error) {
    console.error('Error fetching automations:', error);
    dispatch(fetchAutomationsFailure(error.message || 'Failed to fetch automations'));
  }
};

export const fetchAutomationById = (id) => async (dispatch) => {
  try {
    dispatch(fetchAutomationsStart());
    const response = await automationService.getAutomation(id);
    return response.data;
  } catch (error) {
    console.error(`Error fetching automation ${id}:`, error);
    dispatch(fetchAutomationsFailure(error.message || 'Failed to fetch automation'));
    throw error;
  }
};

export const createAutomation = (automation) => async (dispatch) => {
  try {
    console.log('Creating automation in thunk:', automation);
    const response = await automationService.createAutomation(automation);
    dispatch(fetchAutomations());
    return response.data;
  } catch (error) {
    console.error('Error creating automation:', error);
    dispatch(fetchAutomationsFailure(error.message || 'Failed to create automation'));
    throw error;
  }
};

export const updateAutomation = (id, automation) => async (dispatch) => {
  try {
    const response = await automationService.updateAutomation(id, automation);
    dispatch(fetchAutomations());
    return response.data;
  } catch (error) {
    console.error(`Error updating automation ${id}:`, error);
    dispatch(fetchAutomationsFailure(error.message || 'Failed to update automation'));
    throw error;
  }
};

export const deleteAutomation = (id) => async (dispatch) => {
  try {
    await automationService.deleteAutomation(id);
    dispatch(fetchAutomations());
  } catch (error) {
    console.error(`Error deleting automation ${id}:`, error);
    dispatch(fetchAutomationsFailure(error.message || 'Failed to delete automation'));
    throw error;
  }
};

export const runAutomation = (id) => async (dispatch) => {
  try {
    const response = await automationService.runAutomation(id);
    dispatch(fetchAutomations());
    return response.data;
  } catch (error) {
    console.error(`Error running automation ${id}:`, error);
    dispatch(fetchAutomationsFailure(error.message || 'Failed to run automation'));
    throw error;
  }
};

export const fetchFolders = () => async (dispatch) => {
  try {
    dispatch(fetchFoldersStart());
    console.log('Fetching folders in thunk');
    
    const response = await automationService.getFolders();
    console.log('Folders response:', response.data);
    
    dispatch(fetchFoldersSuccess(response.data));
  } catch (error) {
    console.error('Error fetching folders:', error);
    dispatch(fetchFoldersFailure(error.message || 'Failed to fetch folders'));
  }
};
